import FormattedMessage from 'I18n/components/FormattedMessage';
import enviro from 'enviro';
import { jsx as _jsx } from "react/jsx-runtime";
const enviromentSuffix = enviro.isQa() ? 'qa' : '';
export const getNavLinks = () => [{
  name: 'communities',
  path: `https://app.hubspot${enviromentSuffix}.com/connect-beta/communities`,
  component: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "connect.marketingSite.header.nav.communities"
  }),
  dataTestId: 'nav-communities-link'
}, {
  name: 'jobs',
  path: `https://app.hubspot${enviromentSuffix}.com/connect-beta/jobs`,
  component: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "connect.marketingSite.header.nav.jobs"
  }),
  dataTestId: 'nav-jobs-link'
}, {
  name: 'people',
  path: `https://app.hubspot${enviromentSuffix}.com/connect-beta/members`,
  component: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "connect.marketingSite.header.nav.people"
  }),
  dataTestId: 'nav-people-link'
}];